import {
  buildingCodesTooltip,
  roomFeaturesTooltip,
  roomLocationTooltip,
  housekeepingTooltip,
  roomMaintainenceTooltip,
  roomDefinitionsTooltip,
  departmentsTooltip,
  categoryTooltip,
  taxesTooltip,
  taxExemptCategoryTooltip,
  guestTypeTooltip,
  postTypesTooltip,
  originsTooltip,
  paymentMethodsTooltip,
  transportationTooltip,
  customerSegmentsTooltip,
  golfTooltipHeaders,
  retailCategoryGroupsTooltip,
  retailRetailSubCategoriesTooltip,
  retailCategoryLinkingTooltip,
  retailRetailCategoriesTooltip,
  retailOutletSetupTooltip,
  retailQuickSaleCategoriesTooltip,
  retailDiscountTypesTooltip,
  retailDiscountReasonsTooltip,
  retailVendorTypesTooltip,
  retailVendorSetupTooltip,
  retailRetailItemsTooltip,
  retailTaxesTooltip,
  retailPaymentMethodsTooltip,
  retailRoleSetupTooltip,
  retailUserSetupTooltip,
  spaTooltipHeaders,
} from "../constants/TooltipInformation";
import {
  reserveSectionTooltip,
  reserveOutletSetupTooltip,
  reserveLocationTooltip,
  reserveTablesTooltip,
  reserveReservationGuestNotesTooltip,
  reserveRowFieldTooltip,
  reserveRolesTooltip,
  reserveUserDetailsTooltip,
  reserveServiceChargeTooltip,
  reserveTaxesTooltip,
  reserveInstructorsTooltip,
  reserveOperationHoursTooltip,
  reserveRatePlanTooltip,
  reserveReservationSettingsTooltip,
  reservePropertyQuestionsTooltip,
  reserveListAvailableHeadingTooltip,
  reservePropertyInformationTooltipHeader,
  reserveUserPermissionsTooltipHeader,
  reserveUserPermissionsTooltipRoleSelect,
  reserveUserPermissionsTooltipPermissionArea,
  reserveUserPermissionsTooltipCategoryBulkSelect,
  reserveMiscItemsTooltipHeader,
  reserveMiscItemsTooltipGuestWaiverFormRequired,
  reserveMiscItemsTooltipConfirmationEmail,
  reserveMiscItemsTooltipUpdateEmail,
  reserveMiscItemsTooltipCancelEmail,
  reserveMiscItemsTooltipAllowBookEditPast,
  reserveMiscItemsTooltipAllowEditCheckedIn,
  reserveMiscItemsTooltipPastDaysToViewEdit,
  reserveMiscItemsTooltipDefaultCommunicationPreference,
  reserveEquipmentsAddonsTooltipHeader,
  reserveEquipmentsAddonsTooltipAddOnName,
  reserveEquipmentsAddonsTooltipAddOnType,
  reserveEquipmentsAddonsTooltipAddOnDescription,
  reserveEquipmentsAddonsTooltipAddOnCategory,
  reserveEquipmentsAddonsTooltipAddOnSubCategory,
  reserveEquipmentsAddonsTooltipQtyInStock,
  reserveEquipmentsAddonsTooltipPricingType,
  reserveEquipmentsAddonsTooltipPrice,
  reserveEquipmentsAddonsTooltipAdditionalRatesPerMins,
  reserveActivitiesTooltipHeader,
  reserveActivitiesTooltipActivityCode,
  reserveActivitiesTooltipActivityName,
  reserveActivitiesTooltipActivityType,
  reserveActivitiesTooltipClassType,
  reserveActivitiesTooltipActivityDescription,
  reserveActivitiesTooltipActivityCategory,
  reserveActivitiesTooltipActivitySubCategory,
  reserveActivitiesTooltipMinGroupSize,
  reserveActivitiesTooltipMaxGroupSize,
  reserveActivitiesTooltipMinActivityStrength,
  reserveActivitiesTooltipMaxActivityStrength,
  reserveActivitiesTooltipAllowOverbookReservation,
  reserveActivitiesTooltipAllowStandbyReservation,
  reserveActivitiesTooltipAutoConfirmStandbyAfterCancellation,
  reserveActivitiesTooltipMaxStandbyStrength,
  reserveActivitiesTooltipGuestType,
  reserveActivitiesTooltipGuestTypePricing,
  reserveActivitiesTooltipMembershipType,
  reserveActivitiesTooltipMembershipPricing,
  reserveActivitiesTooltipStartDate,
  reserveActivitiesTooltipEndDate,
  reserveActivitiesTooltipDaysOfTheWeek,
  reserveActivitiesTooltipStartEndTime,
  reserveActivitiesTooltipStartTime,
  reserveActivitiesTooltipEndTime,
  reserveActivitiesTooltipNumberOfLocations,
  reserveActivitiesTooltipLocationName,
  reserveActivitiesTooltipStaffGuide,
  reserveActivitiesTooltipRequirePrepayment,
  reserveActivitiesTooltipPaymentType,
  reserveActivitiesTooltipBasePrice,
  reserveActivitiesTooltipCancellationFeeRequired,
  reserveActivitiesTooltipCancellationFeeType,
  reserveActivitiesTooltipCancellationDeadline,
  reserveActivitiesTooltipCancellationPolicyDescription,
  reserveActivitiesTooltipAllowAdditionalGuestDetails,
  reserveActivitiesTooltipCollectAdditionalEmployeeDetails,
  reserveActivitiesTooltipActivityImage,
  reserveActivitiesTooltipReservationParameter,
  reserveActivitiesTooltipAddonsName,
  reserveActivitiesTooltipAvailableForWebReservation,
  reserveActivitiesTooltipCheckInCutoffMinutes,
} from "../constants/ReserveTooltipInformation";
import { ProductEnum } from "../constants/login";
import {
  SNC_SHARED_FOUNDATION_SCREENS,
  SNC_TOOLTIP_BY_SCREEN,
  sncTooltipGroupKey,
} from "../constants/SnCTooltipInformation";
import type { TooltipSeedItem } from "./types";
import {
  resolveTooltipDisplayFieldKey,
  resolveTooltipScreenLabel,
} from "./tooltipScreenMap";

type TooltipGroup = Record<string, string>;

/**
 * SnC-only screens get dedicated snc*Tooltip groups from SnCTooltipInformation.
 * Shared foundation screens (Outlet Setup, Category Groups, …) stay on golfTooltipHeaders.
 */
function buildSnCTooltipGroups(): {
  groups: Record<string, TooltipGroup>;
  products: Record<string, string[]>;
  screens: Record<string, string>;
} {
  const groups: Record<string, TooltipGroup> = {};
  const products: Record<string, string[]> = {};
  const screens: Record<string, string> = {};
  const shared = new Set<string>(SNC_SHARED_FOUNDATION_SCREENS);
  for (const [screen, defaults] of Object.entries(SNC_TOOLTIP_BY_SCREEN)) {
    if (shared.has(screen)) continue;
    const groupKey = sncTooltipGroupKey(screen);
    groups[groupKey] = { ...defaults };
    products[groupKey] = ["SnC"];
    screens[groupKey] = screen;
  }
  return { groups, products, screens };
}

const SNC_TOOLTIP_BUILT = buildSnCTooltipGroups();
/** groupKey → SnC navbar screen label (for admin breadcrumbs / filters). */
export const SNC_TOOLTIP_SCREEN_BY_GROUP: Record<string, string> =
  SNC_TOOLTIP_BUILT.screens;

/** Synthetic groups for Reserve string-export tooltips (one screen each). */
const reservePropertyInformationTooltip: TooltipGroup = {
  header: reservePropertyInformationTooltipHeader,
};
const reserveListAvailableTooltip: TooltipGroup = {
  header: reserveListAvailableHeadingTooltip,
};
const reserveUserPermissionsTooltip: TooltipGroup = {
  header: reserveUserPermissionsTooltipHeader,
  roleSelect: reserveUserPermissionsTooltipRoleSelect,
  permissionArea: reserveUserPermissionsTooltipPermissionArea,
  categoryBulkSelect: reserveUserPermissionsTooltipCategoryBulkSelect,
};
const reserveMiscItemsTooltip: TooltipGroup = {
  header: reserveMiscItemsTooltipHeader,
  guestWaiverFormRequired: reserveMiscItemsTooltipGuestWaiverFormRequired,
  confirmationEmail: reserveMiscItemsTooltipConfirmationEmail,
  updateEmail: reserveMiscItemsTooltipUpdateEmail,
  cancelEmail: reserveMiscItemsTooltipCancelEmail,
  allowBookEditPast: reserveMiscItemsTooltipAllowBookEditPast,
  allowEditCheckedIn: reserveMiscItemsTooltipAllowEditCheckedIn,
  pastDaysToViewEdit: reserveMiscItemsTooltipPastDaysToViewEdit,
  defaultCommunicationPreference:
    reserveMiscItemsTooltipDefaultCommunicationPreference,
};
const reserveEquipmentsAddonsTooltip: TooltipGroup = {
  header: reserveEquipmentsAddonsTooltipHeader,
  addOnName: reserveEquipmentsAddonsTooltipAddOnName,
  addOnType: reserveEquipmentsAddonsTooltipAddOnType,
  addOnDescription: reserveEquipmentsAddonsTooltipAddOnDescription,
  addOnCategory: reserveEquipmentsAddonsTooltipAddOnCategory,
  addOnSubCategory: reserveEquipmentsAddonsTooltipAddOnSubCategory,
  qtyInStock: reserveEquipmentsAddonsTooltipQtyInStock,
  pricingType: reserveEquipmentsAddonsTooltipPricingType,
  price: reserveEquipmentsAddonsTooltipPrice,
  additionalRatesPerMins: reserveEquipmentsAddonsTooltipAdditionalRatesPerMins,
};
const reserveActivitiesTooltip: TooltipGroup = {
  header: reserveActivitiesTooltipHeader,
  activityCode: reserveActivitiesTooltipActivityCode,
  activityName: reserveActivitiesTooltipActivityName,
  activityType: reserveActivitiesTooltipActivityType,
  classType: reserveActivitiesTooltipClassType,
  activityDescription: reserveActivitiesTooltipActivityDescription,
  activityCategory: reserveActivitiesTooltipActivityCategory,
  activitySubCategory: reserveActivitiesTooltipActivitySubCategory,
  minGroupSize: reserveActivitiesTooltipMinGroupSize,
  maxGroupSize: reserveActivitiesTooltipMaxGroupSize,
  minActivityStrength: reserveActivitiesTooltipMinActivityStrength,
  maxActivityStrength: reserveActivitiesTooltipMaxActivityStrength,
  allowOverbookReservation: reserveActivitiesTooltipAllowOverbookReservation,
  allowStandbyReservation: reserveActivitiesTooltipAllowStandbyReservation,
  autoConfirmStandbyAfterCancellation:
    reserveActivitiesTooltipAutoConfirmStandbyAfterCancellation,
  maxStandbyStrength: reserveActivitiesTooltipMaxStandbyStrength,
  guestType: reserveActivitiesTooltipGuestType,
  guestTypePricing: reserveActivitiesTooltipGuestTypePricing,
  membershipType: reserveActivitiesTooltipMembershipType,
  membershipPricing: reserveActivitiesTooltipMembershipPricing,
  startDate: reserveActivitiesTooltipStartDate,
  endDate: reserveActivitiesTooltipEndDate,
  daysOfTheWeek: reserveActivitiesTooltipDaysOfTheWeek,
  startEndTime: reserveActivitiesTooltipStartEndTime,
  startTime: reserveActivitiesTooltipStartTime,
  endTime: reserveActivitiesTooltipEndTime,
  numberOfLocations: reserveActivitiesTooltipNumberOfLocations,
  locationName: reserveActivitiesTooltipLocationName,
  staffGuide: reserveActivitiesTooltipStaffGuide,
  requirePrepayment: reserveActivitiesTooltipRequirePrepayment,
  paymentType: reserveActivitiesTooltipPaymentType,
  basePrice: reserveActivitiesTooltipBasePrice,
  cancellationFeeRequired: reserveActivitiesTooltipCancellationFeeRequired,
  cancellationFeeType: reserveActivitiesTooltipCancellationFeeType,
  cancellationDeadline: reserveActivitiesTooltipCancellationDeadline,
  cancellationPolicyDescription:
    reserveActivitiesTooltipCancellationPolicyDescription,
  allowAdditionalGuestDetails:
    reserveActivitiesTooltipAllowAdditionalGuestDetails,
  collectAdditionalEmployeeDetails:
    reserveActivitiesTooltipCollectAdditionalEmployeeDetails,
  activityImage: reserveActivitiesTooltipActivityImage,
  reservationParameter: reserveActivitiesTooltipReservationParameter,
  addonsName: reserveActivitiesTooltipAddonsName,
  availableForWebReservation:
    reserveActivitiesTooltipAvailableForWebReservation,
  checkInCutoffMinutes: reserveActivitiesTooltipCheckInCutoffMinutes,
};

/**
 * Each group is owned by one or more products. Groups used across products
 * are seeded once per product so each product’s Tooltip Admin can edit independently.
 * Golf headers are Golf-only (not Spa/SnC).
 */
export const TOOLTIP_GROUP_PRODUCTS: Record<string, string[]> = {
  buildingCodesTooltip: ["Versa"],
  roomFeaturesTooltip: ["Versa"],
  roomLocationTooltip: ["Versa"],
  housekeepingTooltip: ["Versa"],
  roomMaintainenceTooltip: ["Versa"],
  roomDefinitionsTooltip: ["Versa"],
  departmentsTooltip: ["Versa"],
  categoryTooltip: ["Versa"],
  taxesTooltip: ["Versa"],
  taxExemptCategoryTooltip: ["Versa"],
  guestTypeTooltip: ["Versa"],
  postTypesTooltip: ["Versa"],
  originsTooltip: ["Versa"],
  paymentMethodsTooltip: ["Versa"],
  transportationTooltip: ["Versa"],
  customerSegmentsTooltip: ["Versa"],
  golfTooltipHeaders: ["Golf"],
  retailCategoryGroupsTooltip: ["Retail"],
  retailRetailSubCategoriesTooltip: ["Retail"],
  retailCategoryLinkingTooltip: ["Retail"],
  retailRetailCategoriesTooltip: ["Retail"],
  retailOutletSetupTooltip: ["Retail"],
  retailQuickSaleCategoriesTooltip: ["Retail"],
  retailDiscountTypesTooltip: ["Retail"],
  retailDiscountReasonsTooltip: ["Retail"],
  retailVendorTypesTooltip: ["Retail"],
  retailVendorSetupTooltip: ["Retail"],
  retailRetailItemsTooltip: ["Retail"],
  retailTaxesTooltip: ["Retail"],
  retailPaymentMethodsTooltip: ["Retail"],
  retailRoleSetupTooltip: ["Retail"],
  retailUserSetupTooltip: ["Retail"],
  spaTooltipHeaders: ["Spa"],
  reserveSectionTooltip: ["Reserve"],
  reserveOutletSetupTooltip: ["Reserve"],
  reserveLocationTooltip: ["Reserve"],
  reserveTablesTooltip: ["Reserve"],
  reserveReservationGuestNotesTooltip: ["Reserve"],
  reserveRowFieldTooltip: ["Reserve"],
  reserveRolesTooltip: ["Reserve"],
  reserveUserDetailsTooltip: ["Reserve"],
  reserveUserPermissionsTooltip: ["Reserve"],
  reserveServiceChargeTooltip: ["Reserve"],
  reserveTaxesTooltip: ["Reserve"],
  reserveInstructorsTooltip: ["Reserve"],
  reserveMiscItemsTooltip: ["Reserve"],
  reserveEquipmentsAddonsTooltip: ["Reserve"],
  reserveActivitiesTooltip: ["Reserve"],
  reserveOperationHoursTooltip: ["Reserve"],
  reserveRatePlanTooltip: ["Reserve"],
  reserveReservationSettingsTooltip: ["Reserve"],
  reservePropertyQuestionsTooltip: ["Reserve"],
  reservePropertyInformationTooltip: ["Reserve"],
  reserveListAvailableTooltip: ["Reserve"],
  ...SNC_TOOLTIP_BUILT.products,
};

/** @deprecated use TOOLTIP_GROUP_PRODUCTS — primary product for display */
export const TOOLTIP_GROUP_PRODUCT: Record<string, string> = Object.fromEntries(
  Object.entries(TOOLTIP_GROUP_PRODUCTS).map(([group, products]) => [
    group,
    products[0],
  ]),
);

const TOOLTIP_GROUPS: Record<string, TooltipGroup> = {
  buildingCodesTooltip,
  roomFeaturesTooltip,
  roomLocationTooltip,
  housekeepingTooltip,
  roomMaintainenceTooltip,
  roomDefinitionsTooltip,
  departmentsTooltip,
  categoryTooltip,
  taxesTooltip,
  taxExemptCategoryTooltip,
  guestTypeTooltip,
  postTypesTooltip,
  originsTooltip,
  paymentMethodsTooltip,
  transportationTooltip,
  customerSegmentsTooltip,
  golfTooltipHeaders,
  retailCategoryGroupsTooltip,
  retailRetailSubCategoriesTooltip,
  retailCategoryLinkingTooltip,
  retailRetailCategoriesTooltip,
  retailOutletSetupTooltip,
  retailQuickSaleCategoriesTooltip,
  retailDiscountTypesTooltip,
  retailDiscountReasonsTooltip,
  retailVendorTypesTooltip,
  retailVendorSetupTooltip,
  retailRetailItemsTooltip,
  retailTaxesTooltip,
  retailPaymentMethodsTooltip,
  retailRoleSetupTooltip,
  retailUserSetupTooltip,
  spaTooltipHeaders,
  reserveSectionTooltip,
  reserveOutletSetupTooltip,
  reserveLocationTooltip,
  reserveTablesTooltip,
  reserveReservationGuestNotesTooltip,
  reserveRowFieldTooltip,
  reserveRolesTooltip,
  reserveUserDetailsTooltip,
  reserveUserPermissionsTooltip,
  reserveServiceChargeTooltip,
  reserveTaxesTooltip,
  reserveInstructorsTooltip,
  reserveMiscItemsTooltip,
  reserveEquipmentsAddonsTooltip,
  reserveActivitiesTooltip,
  reserveOperationHoursTooltip,
  reserveRatePlanTooltip,
  reserveReservationSettingsTooltip,
  reservePropertyQuestionsTooltip,
  reservePropertyInformationTooltip,
  reserveListAvailableTooltip,
  ...SNC_TOOLTIP_BUILT.groups,
};

export const TOOLTIP_PRODUCT_CODES = [
  "Versa",
  "Golf",
  "Spa",
  "Retail",
  "SnC",
  "Reserve",
] as const;

export function tooltipLookupKey(groupKey: string, fieldKey: string): string {
  return `${groupKey}::${fieldKey}`;
}

/**
 * Admin display: screen → field.
 * Golf/Spa flat bags resolve screen from field map/prefix (not just "Golf"/"Spa").
 * (API keys stay as groupKey/fieldKey.)
 */
export function formatTooltipGroupLabel(
  groupKey: string,
  fieldKey?: string,
): string {
  if (fieldKey) {
    const fromScreen = resolveTooltipScreenLabel(groupKey, fieldKey);
    if (fromScreen) return fromScreen;
  }
  const withoutSuffix = groupKey
    .replace(/TooltipHeaders$/i, "")
    .replace(/Headers$/i, "")
    .replace(/Tooltip$/i, "");
  const spaced = withoutSuffix
    .replace(/([a-z0-9])([A-Z])/g, "$1 $2")
    .replace(/[_-]+/g, " ")
    .trim();
  if (!spaced) return groupKey;
  return spaced
    .split(/\s+/)
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
    .join(" ");
}

export function formatTooltipFieldLabel(
  fieldKey: string,
  groupKey?: string,
): string {
  const keyForLabel = groupKey
    ? resolveTooltipDisplayFieldKey(groupKey, fieldKey)
    : fieldKey;
  // Page-level header tooltips
  if (
    keyForLabel === "Header" ||
    keyForLabel === "Headers" ||
    /^(header|headers)$/i.test(keyForLabel)
  ) {
    return "Page header";
  }
  if (fieldKey.endsWith("Header") || fieldKey.endsWith("Headers")) {
    if (groupKey === "golfTooltipHeaders" || groupKey === "spaTooltipHeaders") {
      return "Page header";
    }
  }
  const spaced = keyForLabel
    .replace(/([a-z0-9])([A-Z])/g, "$1 $2")
    .replace(/[_-]+/g, " ")
    .trim();
  if (!spaced) return fieldKey;
  return spaced.charAt(0).toUpperCase() + spaced.slice(1);
}

/** Unicode arrow (U+2192) — reliable in UI; avoid ASCII "->" which can look broken. */
export const TOOLTIP_LABEL_ARROW = "\u2192";

export function formatTooltipAdminLabel(
  groupKey: string,
  fieldKey: string,
): string {
  return `${formatTooltipGroupLabel(groupKey, fieldKey)} ${TOOLTIP_LABEL_ARROW} ${formatTooltipFieldLabel(fieldKey, groupKey)}`;
}

/** Map session ProductEnum / display name → tooltip productCode. */
export function tooltipProductCodeForSession(
  productName: string | undefined | null,
): string {
  switch (productName) {
    case ProductEnum.VERSA:
    case "Versa":
      return "Versa";
    case ProductEnum.GOLF:
    case "Golf":
      return "Golf";
    case ProductEnum.SPA:
    case "Spa":
      return "Spa";
    case ProductEnum.RETAIL:
    case "Retail":
      return "Retail";
    case ProductEnum.SALES_AND_CATETING:
    case "Sales and Catering":
    case "SnC":
      return "SnC";
    case ProductEnum.RESERVE_ACTIVITIES:
    case ProductEnum.RESERVE_DINING:
    case "Reserve Activities":
    case "Reserve Dining":
    case "Reserve":
      return "Reserve";
    default:
      return String(productName ?? "Versa");
  }
}

/** Flatten TooltipInformation.ts into seed/API catalog rows (one row per product ownership). */
export function flattenTooltipCatalog(
  productCodeFilter?: string,
): TooltipSeedItem[] {
  const items: TooltipSeedItem[] = [];
  for (const [groupKey, group] of Object.entries(TOOLTIP_GROUPS)) {
    const products = TOOLTIP_GROUP_PRODUCTS[groupKey] ?? [];
    for (const productCode of products) {
      if (productCodeFilter && productCode !== productCodeFilter) continue;
      for (const [fieldKey, defaultText] of Object.entries(group)) {
        if (typeof defaultText !== "string") continue;
        items.push({
          productCode,
          groupKey,
          fieldKey,
          defaultText,
          description: `${productCode}.${groupKey}.${fieldKey}`,
        });
      }
    }
  }
  return items;
}

let staticMapCache: Map<string, string> | null = null;
let defaultTextToKeyCache: Map<string, string> | null = null;

function buildStaticMaps(): {
  byKey: Map<string, string>;
  byDefaultText: Map<string, string>;
} {
  const byKey = new Map<string, string>();
  const byDefaultText = new Map<string, string>();
  // Static fallback is by group+field (same default copy across products until DB overrides)
  for (const [groupKey, group] of Object.entries(TOOLTIP_GROUPS)) {
    for (const [fieldKey, defaultText] of Object.entries(group)) {
      if (typeof defaultText !== "string") continue;
      const key = tooltipLookupKey(groupKey, fieldKey);
      byKey.set(key, defaultText);
      if (!byDefaultText.has(defaultText)) {
        byDefaultText.set(defaultText, key);
      }
    }
  }
  return { byKey, byDefaultText };
}

export function getStaticTooltipMap(): Map<string, string> {
  if (!staticMapCache) {
    const maps = buildStaticMaps();
    staticMapCache = maps.byKey;
    defaultTextToKeyCache = maps.byDefaultText;
  }
  return staticMapCache;
}

export function getDefaultTextToKeyMap(): Map<string, string> {
  if (!defaultTextToKeyCache) {
    getStaticTooltipMap();
  }
  return defaultTextToKeyCache!;
}

export function getStaticTooltip(
  groupKey: string,
  fieldKey: string,
): string {
  return getStaticTooltipMap().get(tooltipLookupKey(groupKey, fieldKey)) ?? "";
}

/** Product codes to fetch for runtime — only the active product’s catalog. */
export function productCodesForRuntime(activeProductName: string): string[] {
  return [tooltipProductCodeForSession(activeProductName)];
}

export function getTooltipGroupKeys(productCode?: string): string[] {
  const keys = Object.keys(TOOLTIP_GROUP_PRODUCTS);
  if (!productCode) return keys;
  return keys.filter((g) =>
    (TOOLTIP_GROUP_PRODUCTS[g] ?? []).includes(productCode),
  );
}
